// extracted by mini-css-extract-plugin
module.exports = {"forgot-password__form":"forgot-password-form_forgot-password__form__MafaI","forgot-password__submit":"forgot-password-form_forgot-password__submit__hW9bw"};